import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';
import {MatDialog} from '@angular/material/dialog';
import { CreateAdministratorComponent } from 'src/app/components/modals/create-administrator/create-administrator.component';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {
  private perPage=20;
  public loadingMembers:boolean=true;
  public paginatedMembers = new BehaviorSubject<any>(null);
  public availableFilters=[];
  private filterString='';

  constructor(
    public dialog: MatDialog,
    private _member: MemberService
  ) {
    this.availableFilters.push(new FilterOption({name:'first_name',type:'string'}));
    this.availableFilters.push(new FilterOption({name:'last_name',type:'string'}));
    this.availableFilters.push(new FilterOption({name:'email',type:'string'}));
  }

  public getAdmins(page){
    this._member.getPaginatedAdmins(page, this.perPage, this.filterString).subscribe(
      paginatedData=>{
        this.paginatedMembers.next(paginatedData);
        this.loadingMembers=false;
      }
    );
  }

  public createNewAdmin(){
    const dialogRef = this.dialog.open(CreateAdministratorComponent, {
      width: '450px',
      panelClass: 'ng-modal-custom'
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result) this.getAdmins(1);
    });
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getAdmins(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getAdmins(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getAdmins(1);
  }

  ngOnInit() {
    this.getAdmins(1);
  }

}
